import { createFileRoute } from '@tanstack/react-router'

import { DispatchesPage } from '#/modules/activity/dispatches-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/dispatches')({
  component: DispatchesPage,
  validateSearch: validateListSearch,
})
